import type { PushRegistrar, PushRegistrationStatus } from '@ngsos/portal-core';

import { emsApi } from '@/api/emsApi';
import {
  isAvailable as pushIsAvailable,
  isSubscribed as pushIsSubscribed,
  requestSubscription,
  requestUnsubscribe,
} from '@/push/notificationsService';

async function currentStatus(): Promise<PushRegistrationStatus> {
  const supported = await pushIsAvailable();
  const enabled = supported ? await pushIsSubscribed() : false;
  return { supported, criticalSupported: false, enabled, criticalEnabled: false };
}

export const webPushRegistrar: PushRegistrar = {
  async getStatus() {
    const status = await currentStatus();
    if (status.enabled) {
      try {
        const subscription = await requestSubscription();
        if (subscription != null) {
          await emsApi.POST('/portal/v1/push/subscribe', {
            body: {
              endpoint: subscription.endpoint,
              p256Dh: subscription.p256dh,
              auth: subscription.auth,
            },
          });
        }
      } catch (error) {
        console.warn('Failed to reconcile push subscription with the server.', error);
      }
    }
    return status;
  },

  async enable() {
    const subscription = await requestSubscription();
    if (subscription == null) {
      return currentStatus();
    }
    const { response } = await emsApi.POST('/portal/v1/push/subscribe', {
      body: {
        endpoint: subscription.endpoint,
        p256Dh: subscription.p256dh,
        auth: subscription.auth,
      },
    });
    if (!response.ok) {
      await requestUnsubscribe();
      throw new Error(`Failed to subscribe to push notifications (HTTP ${response.status})`);
    }
    return currentStatus();
  },

  async disable() {
    const endpoint = await requestUnsubscribe();
    if (endpoint != null) {
      const { response } = await emsApi.POST('/portal/v1/push/unsubscribe', {
        body: { endpoint },
      });
      if (!response.ok) {
        throw new Error(`Failed to unsubscribe from push notifications (HTTP ${response.status})`);
      }
    }
    return currentStatus();
  },

  setCritical() {
    return currentStatus();
  },
};
